var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnedpageanalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.131,
    height: 19.864,
    viewBox: "0 0 15.131 19.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2059.381 11836.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1998.381 -11836.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.746,19.864H74.385a1.748,1.748,0,0,0,1.746-1.746V5.82H72.057a1.748,1.748,0,0,1-1.746-1.746V0H62.746A1.748,1.748,0,0,0,61,1.746V18.118A1.748,1.748,0,0,0,62.746,19.864Z",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.582,13.1h3.733L331,8.789v3.733A.582.582,0,0,0,331.582,13.1Z",
    transform: "translate(-259.525 -8.448)",
    fill: "#697384"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2062 -11869.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.836,104.367a.367.367,0,0,0-.367-.367h-1.1a.367.367,0,0,0-.367.367v2.571h1.836Z",
    transform: "translate(-31.238 -60.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.836,72.367A.367.367,0,0,0,89.469,72h-1.1a.367.367,0,0,0-.367.367v4.04h1.836Z",
    transform: "translate(-84.223 -29.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.836,40.429a.4.4,0,0,0-.367-.429h-1.1a.4.4,0,0,0-.367.429v6.43h1.836Z",
    transform: "translate(-137.208)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2112.587 -11828.874) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.332,40.744c.01-.019-1.363-.009-1.332,0V52.458h1.332Z",
    transform: "translate(-135.208 -1)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnedpageanalytics);
export default __webpack_public_path__ + "static/media/ownedpageanalytics.0598c036afc5ed97073c4e6d61fc8de9.svg";
export { ForwardRef as ReactComponent };